import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCalendarNavigation } from '../context/CalendarNavigationContext';

const MobileNavigation = ({
  prevLabel = '‹',
  nextLabel = '›',
  className = '',
}) => {
  const { t } = useTranslation('calendar');
  const {
    weekLabel,
    goToPrevWeek,
    goToNextWeek,
  } = useCalendarNavigation();

  return (
    <div className={`calendar-mobile__navigation ${className}`}>
      <button
        type="button"
        className="calendar-mobile__nav-btn"
        onClick={goToPrevWeek}
        aria-label={t('navigation.previousWeek')}
      >
        {prevLabel}
      </button>

      <div className="calendar-mobile__nav-current">
        {weekLabel}
      </div>

      <button
        type="button"
        className="calendar-mobile__nav-btn"
        onClick={goToNextWeek}
        aria-label={t('navigation.nextWeek')}
      >
        {nextLabel}
      </button>
    </div>
  );
};

export default MobileNavigation;
